import { render, staticRenderFns } from "./NewMessageForm.vue?vue&type=template&id=e6aa680e&scoped=true&"
import script from "./NewMessageForm.vue?vue&type=script&lang=js&"
export * from "./NewMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageForm.vue?vue&type=style&index=0&id=e6aa680e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aa680e",
  null
  
)

export default component.exports